import {useEffect, useState} from 'react';
import {useFetchPostData} from './useFetchData'
import {useQueryParams} from './useLocationData'
import miscPageMapping from '../data/mapping/pages/miscPageMapping';
import miscPageMockData from '../data/miscPage.json';

const useMiscPageData = (pagePath) => {
    const queryKey = 'miscData' + pagePath;
    const queryParams = useQueryParams();
    const isMockData = queryParams.get('useMockData') === 'true';
    const [miscPageQueryData, setGlobalData] = useState('');

    const { isLoading, error, data } = useFetchPostData(queryKey, pagePath, isMockData);
    useEffect(() => {
      if (data && !isMockData) {
        const mappedData = miscPageMapping(data);
        setGlobalData(mappedData);
      }
    }, [data, isMockData])

    if (isMockData) {
      return {
        error: false,
        isLoading: false,
        miscPageQueryData: miscPageMockData
      };
    }

    return  {
      error,
      isLoading,
      miscPageQueryData
    };
}

export default useMiscPageData;
